<template>
  <el-aside>
    <div class="aside_bg">
      <el-menu :default-active="menuActiveId" class="el-menu-vertical-demo">
        <router-link
          :to="{ path: '/eventDetail', query: { eventId: eventId } }"
        >
          <el-menu-item index="1">
            <i class="el-icon-menu"></i>
            <span slot="title">会议详情</span>
          </el-menu-item>
        </router-link>
        <router-link
          v-if="eventDesc.has_sub_forum === true"
          :to="{ path: '/subEvent', query: { eventId: eventId } }"
        >
          <el-menu-item index="2">
            <i class="el-icon-document"></i>
            <span slot="title">分会议</span>
          </el-menu-item>
        </router-link>
        <router-link
          :to="{ path: '/eventSchedule', query: { eventId: eventId } }"
        >
          <el-menu-item index="3">
            <i class="el-icon-setting"></i>
            <span slot="title">日程安排</span>
          </el-menu-item>
        </router-link>
        <router-link
          :to="{ path: '/famousScholar', query: { eventId: eventId } }"
        >
          <el-menu-item index="4">
            <i class="el-icon-setting"></i>
            <span slot="title">知名学者</span>
          </el-menu-item>
        </router-link>
        <router-link
          :to="{ path: '/eventContact', query: { eventId: eventId } }"
        >
          <el-menu-item index="5">
            <i class="el-icon-phone"></i>
            <span slot="title">联系方式</span>
          </el-menu-item>
        </router-link>
      </el-menu>
    </div>
  </el-aside>
</template>

<script>
export default {
  name: 'EventMenu',
  props: {
    menuActiveId: String,
  },
  computed: {
    eventDesc: {
      get() {
        return this.$store.state.toGetCurrentEvent.currentEvent;
      },
    },
  },
  data() {
    return {
      eventId: '',
    };
  },
  mounted() {
    let eventId = this.$route.query.eventId;
    // console.log( 'menu' + eventId);
    this.eventId = eventId;
  },
};
</script>

<style scoped></style>
